// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__sNKqp","logoContainer":"sidebar_logoContainer__w6O-O"};